import { Component,ViewChild } from '@angular/core';
import { NavController,Slides, IonicPage, NavParams } from 'ionic-angular';

/**
 * Generated class for the EnregistrerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-enregistrer',
  templateUrl: 'enregistrer.html',
})
export class EnregistrerPage {
  @ViewChild('slider') slider: Slides;
  douleurs = [
    'Brûlure',
    'Chaleur',
    'Tiraillement',
    'Fulgurante',
    'Sourde',
    'Régulière',
    'Palpitante',
    'Serrement',
    'Démangeaisons',
    'Fourmillements',
    'Profonde',
    'Superficielle',
    'Irradiante'
  ];
  selectOptions = {
    title: 'Type de douleur',
  };
  enregistrement:any;
  currentIndex = 0;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.initEnregistrement();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad EnregistrerPage');
  }
  footerButton(){
    // this.slider.lockSwipes(false);
    this.slider.slideNext();
    // this.slider.lockSwipes(true);
  }

  initEnregistrement(){
    let enregistrement = {
      date: new Date().toISOString(),
      description: '',
      duree: 0,
      intensite: 0,
      condition: '',
      type:''
    };
    this.enregistrement = enregistrement;
    console.log(this.enregistrement);
  }

  goBack(){
    this.navCtrl.pop();
  }


  // On slide changed
  slideChanged() {
    this.currentIndex = this.slider.getActiveIndex();
  }

}



// WEBPACK FOOTER //
// ./src/pages/enregistrer/enregistrer.ts